import PropTypes from 'prop-types';
import React, { createContext, useEffect, useRef, useState } from 'react';

/* ========================================================================= */
/* Context */
/* ========================================================================= */

/**
 * The size of a single grid cell, in pixels. Cells are square, so this is both
 * the column width and the row height. Zero until measured.
 */
export const GridCellSizeContext = createContext(0);

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * GridWrapper layout component
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const GridWrapper = ({ children }) => {
    const gridRef = useRef();
    const [cellSize, setCellSize] = useState(0);

    useEffect(() => {
        if (!gridRef.current || typeof ResizeObserver !== 'function') { return () => {}; }

        const measure = () => {
            const [firstTrack] = window.getComputedStyle(gridRef.current).gridTemplateColumns.split(' ');
            setCellSize(parseFloat(firstTrack) || 0);
        };

        const observer = new ResizeObserver(measure);
        observer.observe(gridRef.current);

        return () => observer.disconnect();
    }, []);

    /* Outer grid */
    return (
        <div className='w-full overflow-hidden rounded'>
            <div
                className='grid grid-cols-3 sm:grid-cols-5 md:grid-cols-7 lg:grid-cols-9 bg-background -mr-1'
                ref={gridRef}>
                <GridCellSizeContext.Provider value={cellSize}>
                    {children}
                </GridCellSizeContext.Provider>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    children: PropTypes.any,
};

GridWrapper.propTypes = propTypes;

export default GridWrapper;
